import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from 'models/Tenant/api'


const initialState = {
  ...baseModelState,
}


export const tenant = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateTenant);
  },
});

export default tenant.reducer;

export const TenantActions = tenant.actions;
